import { GenerationPreset } from "@next-platform/packages-ts-types";
import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { NotificationType, useGenerationPresets, useTranslation } from "@next-platform/client-common-core";
import React from "react";

import { Col } from "@/components";
import Trans from "@/components/Trans/Trans";
import { useInferenceSettings } from "@/hooks";
import useToast from "@/hooks/useToast";
import ModelSelectionHeader from "@/pages/Chat/components/ModelSelectionDropdown/ModelSelectionHeader";
import PresetSelectionItem from "@/pages/Chat/components/ModelSelectionDropdown/PresetSelectionItem";

const PresetSelectionView = ({
  toggleView,
  closeDropdown,
}: {
  toggleView: () => void;
  closeDropdown: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();
  const { displayToast } = useToast();
  const { availablePresets, getModelNameById, getPresetSettings } = useGenerationPresets();
  const { applyInferenceSettings } = useInferenceSettings();

  const handlePresetSelect = (preset: GenerationPreset) => {
    const settings = getPresetSettings(preset.id);
    if (!settings) return;

    applyInferenceSettings(settings);

    displayToast({
      message: t("chat:page.header.modelSelection.dropdown.presetSelection.toast.success", { name: preset.name }),
      type: NotificationType.success,
    });
    closeDropdown(false);
  };

  return (
    <Col className="py-sm">
      <ModelSelectionHeader
        canGoBack={true}
        clickHandler={toggleView}
        title={t("chat:modal.generationSettings.presets.titleWithCount", { count: availablePresets.length })}
      />
      <Col className="max-w-[330px] max-h-[531px] overflow-y-auto custom-scroll">
        {availablePresets.length > 0 ? (
          availablePresets.map((preset: GenerationPreset) => (
            <PresetSelectionItem key={preset.id} preset={preset} modelName={getModelNameById(preset.modelId)} onSelect={handlePresetSelect} />
          ))
        ) : (
          <div className="px-[18px] py-8 text-center">
            <Text variant={TextVariants.LABEL_MEDIUM_REGULAR} className="text-gray-11">
              <Trans i18nKey="chat:modal.generationSettings.presets.emptyTitle" />
            </Text>
            <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-10 mt-2">
              <Trans i18nKey="chat:modal.generationSettings.presets.emptyDescription" />
            </Text>
          </div>
        )}
      </Col>
    </Col>
  );
};

export default PresetSelectionView;
